var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7426 8.52939L21.4707 0.257461C21.3058 0.0926369 21.0823 0 20.8492 0H9.15084C8.91775 0 8.69422 0.0926369 8.52939 0.257461L0.257461 8.52939C0.0926369 8.69422 0 8.91775 0 9.15084V20.8492C0 21.0822 0.0926369 21.3058 0.257461 21.4706L8.52939 29.7425C8.69422 29.9074 8.91775 30 9.15084 30H20.8492C21.0822 30 21.3058 29.9074 21.4706 29.7425L29.7425 21.4706C29.9074 21.3058 30 21.0822 30 20.8492V9.15084C30.0001 8.91775 29.9074 8.69422 29.7426 8.52939ZM28.2422 20.4851L20.4851 28.2422H9.51494L1.75782 20.4851V9.51494L9.51494 1.75782H20.4852L28.2422 9.51494V20.4851Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0509 5.33203H12.9493C12.4354 5.33203 12.0306 5.77178 12.0734 6.28418L12.9553 16.8311C12.9933 17.2865 13.3741 17.6367 13.8311 17.6367H16.169C16.6261 17.6367 17.0068 17.2865 17.0449 16.8311L17.9267 6.28418C17.9695 5.77207 17.5651 5.33203 17.0509 5.33203ZM15.3605 15.8789H14.6396L13.9047 7.08985H16.0954L15.3605 15.8789Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.001 19.3945C13.5487 19.3945 12.3672 20.5761 12.3672 22.0283V22.0342C12.3672 23.4865 13.5487 24.668 15.001 24.668C16.4532 24.668 17.6348 23.4864 17.6348 22.0283C17.6348 20.5761 16.4533 19.3945 15.001 19.3945ZM15.001 22.9102C14.5179 22.9102 14.125 22.5172 14.125 22.0342V22.0283C14.125 21.5453 14.518 21.1523 15.001 21.1523C15.484 21.1523 15.877 21.5453 15.877 22.0342C15.877 22.5172 15.484 22.9102 15.001 22.9102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationError);
export default __webpack_public_path__ + "static/media/notification-error.92c63bd8bd9af52211d713711dda122f.svg";
export { ForwardRef as ReactComponent };